// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__syu-O","cardHeader":"styles_cardHeader__XsJJZ","card":"styles_card__UI+RA","revenue":"styles_revenue__HnqUj","payment":"styles_payment__c4VGg"};